<script>


import PerPageSelect from "@/components/ui/PerPageSelect.vue";

export default {
    components: {PerPageSelect},
    data() {
        return {
            loading: true,
            downloading: false,
            firstLoading: true,
            data: [],
            originalData: {},
            meta: {
                current_page: 1,
                total: 0,
                per_page: 0,
            },
            sort: {
                field: 'id',
                order: 'desc'
            },
            controller: new AbortController(),
            perPage: parseInt(localStorage.getItem('perPage_companies') || '10'),
        }
    },
    methods: {
        loadData() {
            this.controller = new AbortController();
            this.loading = true;
            window.scrollTo({top: 0});
            axios.get('/companies/withdrawals', {
                signal: this.controller.signal,
                params: {
                    page: this.meta.current_page,
                    per_page: this.perPage,
                    sort: this.sort.field,
                    order: this.sort.order
                }
            }).then(response => {
                this.data = response.data.data;
                this.meta.current_page = response.data.meta.current_page;
                this.meta.total = response.data.meta.total;
                this.meta.per_page = response.data.meta.per_page;
            }).catch(error => {
            }).finally(() => {
                this.loading = false;
            })
        },
        onPageChange(page) {
            this.controller.abort();
            this.meta.current_page = page;
            this.loadData();
        },
        onSort(field, order) {
            this.controller.abort();
            this.sort = {field, order};
            this.loadData();
        },
        onPerPageChange() {
            localStorage.setItem('perPage_companies', String(this.perPage));
            this.meta.current_page = 1;
            this.loadData();
        },
        download() {
            this.downloading = true;
            let params = {
                sort: this.sort.field,
                order: this.sort.order,
                xlsx: 1
            }
            axios({
                url: '/companies/withdrawals',
                method: 'GET',
                responseType: 'blob',
                params
            }).then((response) => {
                saveAs(response.data, 'company-withdrawals.xlsx');
            }).finally(() => {
                this.downloading = false;
            });
        }
    },
    mounted() {
        this.loadData();
    },
    beforeUnmount() {
        this.controller.abort();
    }
}

</script>
<template>
    <section>

        <div class="mb-4">
            <b-button v-if="$auth.isAdmin()" :loading="downloading" type="is-link" icon-left="download" @click="download">
                .xlsx
            </b-button>
        </div>

        <b-table
            :data="loading ? [] : data"
            :loading="loading"

            :paginated="!loading"
            backend-pagination
            :total="loading ? 0 : meta.total"
            :per-page="perPage"
            @page-change="onPageChange"
            :aria-next-label="$t('navigation.next_page')"
            :aria-previous-label="$t('navigation.previous_page')"
            :aria-page-label="$t('navigation.page')"
            :aria-current-label="$t('navigation.current_page')"

            backend-sorting
            sort-icon="arrow-up"
            default-sort-direction="asc"
            :default-sort="['name', 'asc']"
            @sort="onSort">

            <b-table-column field="name" :label="$t('companies.fields.name.name')"
                            sortable
                            v-slot="props">
                {{ props.row.name }}
            </b-table-column>

            <b-table-column field="withdrawals_count"
                            :label="$t('companies.fields.withdrawals_count.name')"
                            sortable
                            v-slot="props">
                {{ props.row.withdrawals_count }}
            </b-table-column>

            <b-table-column field="withdrawals_token_amount"
                            :label="$t('companies.fields.withdrawals_token_amount.name')"
                            sortable
                            v-slot="props">
                {{ props.row.withdrawals_token_amount ? props.row.withdrawals_token_amount : 0 }}
            </b-table-column>


            <b-table-column field="" label="-" v-slot="props">

                <section class="buttons">

                    <b-button type="is-link"
                              size="is-small"
                              icon-right="eye"
                              @click="$router.push({name: 'companies.show', params: {id: props.row.id}})">
                    </b-button>

                </section>

            </b-table-column>

            <template #bottom-left>
                <PerPageSelect v-model="perPage" @change="onPerPageChange" />
            </template>

        </b-table>

        <loader :loading="loading"></loader>
    </section>
</template>
